<template>
    <rent-select-filter  :class="{error: error.item}" class="select-scroll select-item biz" :selectMsg="obj.selectWord" bgColor="#fff" :setDefault="false">
        <div class="select-filter">
            <img class="search" src="@/assets/img/icon/search_black.svg" alt="">
            <input v-model="obj.filterWord" placeholder="搜尋業務" type="text">
            <!-- <span v-if="item.filterWord" @click="setLandlord" class="add-item">建立房東</span> -->
        </div>
        <ul>
            <li v-for="(item, index) in filterByWord" :key="index" :data-id="item.userCid" @click="seletedWord(index)">
                {{item.name}}
                <!-- <radio :val="item.userCid" v-model="obj.value" :isPropChecked="obj.value == item.userCid" :isLeftMsg="true" :msg="item.name"></radio> -->
            </li>
        </ul>
    </rent-select-filter>
</template>
<script>
import RentSelectFilter from '@/components/bussiness/widges/tools/RentSelectFilter.vue';
import Radio from '@/components/bussiness/widges/input/radio.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            obj:{
                filterWord: null,
                value: null,
                selectWord: this.msg
            },
            error: {
                item: null
            },
        }
    },
    props: {
        msg: null,
    },
    watch: {
        msg: function (val) {
            if(val){
                // this.selectColor = '#676362'
                this.obj.selectWord = val
            }
        },
    },
    methods: {
        seletedWord: function (index) {
            this.obj.selectWord = this.filterByWord[index].name
            this.$emit('getId', this.filterByWord[index].userCid)
        },
    },
    computed: {
        filterByWord: function () {
            return this.list.filter((item) => {
                if( this.obj.filterWord ){
                    console.log(this.obj.filterWord)
                    if( item.name.includes( this.obj.filterWord )){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            list: 'GET_BIZ_DISPATCH_ORG_MEMBER_BY_GROUP_LIST',
        })
    },
    components: {
        RentSelectFilter,
        Radio
    }
}
</script>
<style lang="scss"  >
    .biz-rent-select-filter{
        background: #fff;
        &.select-item{
            padding: 9px 16px;
        }
        span{
            display: flex !important;
        }
        &.select-item{
            .select-filter{
                width: 206px;
                .add-item{
                    color: #3942b5;
                    width: 73px;
                }
            }
            ul{
                width: 206px;
                li{
                    width: 100%;
                    // padding: 0;
                    box-sizing: border-box;
                    // .radio{
                    //     width: 100%;
                    //     .input-radio{
                    //         padding: 12px 16px;
                    //         display: flex;
                    //         align-items: center;
                    //         justify-content: space-between;
                    //         box-sizing: border-box;
                    //     }
                    // }
                    
                    &:first-child{
                        padding-top: 52px ;
                    }
                }
            }
        }   
    }
    
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/input/selectSales.vue